<template>
    <div class="template-header">
        <div class="header-left">
            <button v-if="showBack" class="btn-back" @click="$emit('back')">
                <i class="fas fa-arrow-left"></i>
            </button>
            <h1 class="header-title">{{ title }}</h1>
        </div>

        <div class="header-right">
            <!-- 캘린더 -->
            <div class="date-picker-container" v-click-outside="handleCloseDatePicker">
                <button class="nav-btn" @click="$emit('date-navigate', -1)">
                    <i class="fas fa-chevron-left"></i>
                </button>
                <div class="date-display" @click="handleToggleDatePicker">
                    <span>{{ currentDateDisplay }}</span>
                    <i :class="['fas fa-chevron-down', { rotate: showDatePicker }]"></i>
                </div>
                <button class="nav-btn" @click="$emit('date-navigate', 1)">
                    <i class="fas fa-chevron-right"></i>
                </button>

                <!-- 드롭다운 -->
                <div v-if="showDatePicker" class="date-dropdown">
                    <div class="year-selector">
                        <button @click="$emit('year-change', -1)">
                            <i class="fas fa-chevron-left"></i>
                        </button>
                        <span>{{ currentYear }}</span>
                        <button @click="$emit('year-change', 1)">
                            <i class="fas fa-chevron-right"></i>
                        </button>
                    </div>
                    <div class="month-grid">
                        <button
                            v-for="month in 12"
                            :key="month"
                            :class="['month-btn', { active: month === currentMonth }]"
                            @click="$emit('month-select', month)"
                        >
                            {{ month }}월
                        </button>
                    </div>
                </div>
            </div>

            <!-- 설정 버튼 -->
            <button class="btn-settings" @click="$emit('settings-open')" title="설정">
                <i class="fas fa-cog"></i>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "TemplateHeader",
    directives: {
        clickOutside: {
            bind(el, binding) {
                el.clickOutsideEvent = function (event) {
                    if (!(el === event.target || el.contains(event.target))) {
                        binding.value(event);
                    }
                };
                document.body.addEventListener("click", el.clickOutsideEvent);
            },
            unbind(el) {
                document.body.removeEventListener("click", el.clickOutsideEvent);
            },
        },
    },
    props: {
        title: {
            type: String,
            default: "대시보드",
        },
        showBack: {
            type: Boolean,
            default: false,
        },
        currentYear: {
            type: Number,
            required: true,
        },
        currentMonth: {
            type: Number,
            required: true,
        },
        showDatePicker: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        currentDateDisplay() {
            return `${this.currentYear}년 ${this.currentMonth}월`;
        },
    },
    methods: {
        handleToggleDatePicker() {
            this.$emit("date-picker-toggle");
        },
        handleCloseDatePicker() {
            this.$emit("date-picker-close");
        },
    },
};
</script>

<style scoped>
/* 헤더 */
.template-header {
    background: #94a3b8;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-radius: 8px;
    margin-bottom: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.btn-back {
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: white;
    width: 32px;
    height: 32px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-back:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateX(-2px);
}

.btn-back:focus {
    outline: none;
}

.header-title {
    font-size: 20px;
    font-weight: 700;
    color: white;
    margin: 0;
}

.header-right {
    display: flex;
    align-items: center;
    gap: 12px;
}

.date-picker-container {
    position: relative;
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    padding: 2px;
    z-index: 100;
}

.nav-btn {
    background: transparent;
    border: none;
    padding: 6px 10px;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.9);
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
}

.nav-btn:hover {
    color: white;
    background: rgba(255, 255, 255, 0.2);
}

.nav-btn:focus {
    outline: none;
}

.date-display {
    padding: 6px 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 120px;
    justify-content: center;
    border-radius: 6px;
    transition: all 0.2s ease;
    color: white;
    font-weight: 600;
    font-size: 13px;
}

.date-display:hover {
    background: rgba(255, 255, 255, 0.15);
}

.date-display i {
    font-size: 10px;
    transition: transform 0.2s ease;
}

.date-display i.rotate {
    transform: rotate(180deg);
}

.date-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    z-index: 101;
    margin-top: 6px;
    padding: 16px;
    min-width: 240px;
}

.year-selector {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e2e8f0;
}

.year-selector button {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    padding: 4px 8px;
    cursor: pointer;
    color: #64748b;
    border-radius: 6px;
    transition: all 0.2s ease;
    font-weight: 600;
    font-size: 12px;
}

.year-selector button:focus {
    outline: none;
}

.year-selector button:hover {
    background: #64748b;
    color: white;
    border-color: #64748b;
}

.year-selector span {
    font-size: 14px;
    font-weight: 700;
    color: #1e293b;
}

.month-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
}

.month-btn {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    padding: 8px 4px;
    cursor: pointer;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    transition: all 0.2s ease;
    text-align: center;
}

.month-btn:hover {
    background: #e2e8f0;
    border-color: #cbd5e1;
    color: #1e293b;
}

.month-btn.active {
    background: #64748b;
    border-color: #64748b;
    color: white;
    box-shadow: 0 1px 4px rgba(100, 116, 139, 0.3);
}

.btn-settings {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
    background: rgba(255, 255, 255, 0.2);
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s ease;
}

.btn-settings:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.4);
}

.btn-settings:focus {
    outline: none;
}

.btn-settings i {
    font-size: 14px;
}
</style>
